/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "us-east-1",
    "aws_appsync_graphqlEndpoint": "https://2na6jiz4b5h47glxzuw6yaydt4.appsync-api.us-east-1.amazonaws.com/graphql",
    "aws_appsync_region": "us-east-1",
    "aws_appsync_authenticationType": "API_KEY",
    "aws_appsync_apiKey": "da2-eu2p2jau4fa75bcgyk3vtmn7v4",
    "aws_user_files_s3_bucket": "creekdog-images195253-prod",
    "aws_user_files_s3_bucket_region": "us-east-1"
};


export default awsmobile;
